var _circle, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealtimelocationtracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 144,
    viewBox: "0 0 64 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#C7F760"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4238 17.641V16H36.5762V17.641H27.4238ZM31.125 35.881H32.875V27.2985H31.125V35.881ZM32 48C30.0657 48 28.2498 47.6576 26.5523 46.9727C24.8559 46.2879 23.3713 45.3492 22.0985 44.1567C20.8268 42.9642 19.8258 41.5721 19.0955 39.9803C18.3652 38.3885 18 36.6857 18 34.8718C18 33.0579 18.3652 31.3551 19.0955 29.7633C19.8258 28.1726 20.8268 26.7804 22.0985 25.5869C23.3702 24.3944 24.8553 23.4557 26.554 22.7709C28.2503 22.086 30.0657 21.7436 32 21.7436C33.6963 21.7436 35.3367 22.028 36.921 22.5969C38.5042 23.1636 39.9578 23.9666 41.282 25.0059L43.193 23.2139L44.432 24.3758L42.521 26.1678C43.6293 27.4095 44.4863 28.7726 45.0918 30.2572C45.6973 31.7429 46 33.2811 46 34.8718C46 36.6857 45.6348 38.3885 44.9045 39.9803C44.1742 41.571 43.1732 42.9631 41.9015 44.1567C40.6298 45.3492 39.1452 46.2879 37.4477 46.9727C35.7502 47.6576 33.9343 48 32 48ZM32 46.359C35.3833 46.359 38.2708 45.2376 40.6625 42.9949C43.0542 40.7521 44.25 38.0444 44.25 34.8718C44.25 31.6991 43.0542 28.9915 40.6625 26.7487C38.2708 24.506 35.3833 23.3846 32 23.3846C28.6167 23.3846 25.7292 24.506 23.3375 26.7487C20.9458 28.9915 19.75 31.6991 19.75 34.8718C19.75 38.0444 20.9458 40.7521 23.3375 42.9949C25.7292 45.2376 28.6167 46.359 32 46.359Z",
    fill: "#1E53E8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.8626,
    y1: 72,
    x2: 32.8626,
    y2: 144,
    stroke: "#1E53E8",
    strokeWidth: 1.72518
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtimelocationtracking);
export default __webpack_public_path__ + "static/media/Realtimelocationtracking.ecd4072a0e651eae41646470850ccbe7.svg";
export { ForwardRef as ReactComponent };